import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { TadDialogComponent } from '../tad-dialog/tad-dialog.component';
import { AccountSummaryDialogComponent } from '../account-summary-dialog/account-summary-dialog.component';
import { AsmsService } from '../../services/asms.service';
import { ProvisionsService } from '../../services/provisions.service';
import { combineLatest } from 'rxjs';
import { debounceTime, filter, finalize, map } from 'rxjs/operators';
import { Account } from '../../models/account.model'
import { ProvisionEnvironment } from '../../enums/provision-environment.enum';
import { SizeDialogComponent } from '../size-dialog/size-dialog.component';
import { EnvironmentType } from 'src/app/enums/environment.enum';


export class FormBase {

  region: DisplayObject[] = [
    { value: 'us-east-2', viewValue: 'US East 2 (Default)' },
    { value: 'us-east-1', viewValue: 'US East 1' }
  ]

  env: DisplayObject[] = [
    { value: String(EnvironmentType.Dev), viewValue: 'Dev' },
    { value: String(EnvironmentType.Test), viewValue: 'Test' },
    { value: String(EnvironmentType.Prod), viewValue: 'Prod' },
  ];
  

  size: DisplayObject[] = [
    { value: 'small', viewValue: 'Small' },
    { value: 'medium', viewValue: 'Medium' },
    { value: 'large', viewValue: 'Large' },
  ];

  orgUnit: DisplayObject[] = [
    { value: 'Online', viewValue: 'Online (Default)' },
    { value: 'Public-Isolated', viewValue: 'Public Isolated' },
    { value: 'Intranet', viewValue: 'Intranet' },
    { value: 'DevZone', viewValue: 'DevZone' },

  ];

  favoriteSeason: string | undefined;
  seasons: string[] = ['Winter', 'Spring', 'Summer', 'Autumn'];
  ipRange: DisplayObject[] = new Array();

  mockAccountSummary: any = {
    "account_name": "aws.hard-coded-account-loading-1-178",
    "account_status": 0,
    "asms": 163579,
    "created_at": "2024-02-19T20:14:39.000Z",
    "created_by": "FZVPX8",
    "environment": 1,
    "guid": "16f8496c-d63d-431d-b4cb-af30eedc657f",
    "root_email": "maxis@gm.com",
    "shared_email": "maxis@gm.com",
    "status_content": null,
    "type": 1,
    "updated_at": "2024-02-19T20:14:39.000Z",
    "updated_by": "HZM72L"
  };

  // asmsList: AsmsList[] = [];
  asmsList: any[] = [];

  asmsIsOccupied = new BehaviorSubject<boolean>(false);
  noAsms = new BehaviorSubject<boolean>(false);
  asmsErrorHover = new BehaviorSubject(false);
  isAsmsLoading : boolean = true;
  
  checkingAccountName: boolean = false;
  accountNameValid: boolean = false;
  accountName: string = "";
  ownerEmail: string = "";
  populatingEnv: boolean = false;

  constructor(
    protected router: Router,
    public dialog: MatDialog,
    protected provisionService: ProvisionsService,
    protected asmsService: AsmsService,
  ) { }

  /**
   * Gets a list of ASMSs associated with the user, 
   * if the is not an owner, or associated with any ASMSs, 
   * the appropriate form fields are disabled
   * @param formGroup 
   */
  getAsmsList(formGroup: FormGroup) {
    this.asmsService.getAsmsList().subscribe(res => {
      this.asmsList = res;
      this.isAsmsLoading = false;

      this.noAsms.next(this.asmsList.length <= 0);
      if (this.asmsList.length <= 0){
        formGroup.get('name')?.disable();
        formGroup.get('ownerEmail')?.disable();
        formGroup.get('environment')?.disable();
      }

    });
  }

  cancel() {
    this.router.navigate(['/']);
  }

  openAccountSummaryDialog(account: any) {
    console.log(account);
    let dialogRef = this.dialog.open(AccountSummaryDialogComponent, {
      data: account,
      height: '350px',
      width: '90%',
      maxWidth: '864px',
    });
    dialogRef.afterClosed().subscribe(() => {
      this.router.navigate(['/']);
    })
  }

  /**
   * Returns the viewValue for a selected value in region and env 
   * displayGroups. Purpose: instead of displaying the value, the nicely 
   * formatted viewValue is displayed 
   * @param formControl 
   * @param value 
   * @returns The viewValue of a selected option
   */
  getFormControlViewValue(formControl: string, value: string): string {
    let valueObj;
    switch (formControl) {
      case 'region':
        valueObj = this.region.find(item => item.value === value);
        break;
      case 'environment':
        valueObj = this.env.find(item => item.value === value);
        break;
      case 'orgUnit':
        valueObj = this.orgUnit.find(item => item.value === value);
        break;
      case 'size':
        valueObj = this.size.find(item => item.value === value);
        break;
    }

    return valueObj?.viewValue || "";
  }

  activateTip() {
    this.asmsErrorHover.next(true)
  }

  deactivateTip(){
    this.asmsErrorHover.next(false)
  }
}

interface DisplayObject {
  value: string;
  viewValue: string;
}

interface AccountNameCheckResponse {
  nameAvailable: boolean;
  accountName: string;
}

interface AsmsList {
  asmsId: number;
  ownerEmail: string;
}